import AllBlogPosts from "@/components/blog/AllBlogPosts";
import MainLayout from "@/components/layouts/MainLayout";
import { GetStaticProps } from "next";
import { getPosts } from "@/utils/getPosts";
import Link from "next/link";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";

interface BlogProps {
  posts: {
    slug: string;
    frontMatter: {
      title?: string;
      description?: string;
      date?: string;
      image?: string;
    };
  }[];
}

export default function Blog({ posts }: BlogProps) {
  return (
    <MainLayout>
      <Breadcrumb className="mb-6 mt-2">
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link href="/">Home</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Blog</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
      <AllBlogPosts posts={posts} />
    </MainLayout>
  );
}

export const getStaticProps: GetStaticProps = async () => {
  const posts = getPosts();

  return { props: { posts } };
};
